import { PLOT_PARENT_CATEGORY, PLOT_CHILD_CATEGORY, PLOT_POINT_INPUT_FORMAT, PLANE_RECTANGULAR_CS_ZONE_JP } from "@/config/const";
import _ from "lodash";

const _plotParentCategory = PLOT_PARENT_CATEGORY;
const _plotChildCategory = PLOT_CHILD_CATEGORY;
const _plotPointInputFormat = PLOT_POINT_INPUT_FORMAT;
const _plane_rectangular_cs_zone_jp = PLANE_RECTANGULAR_CS_ZONE_JP;

export default {
  data() {
    return {
      plotParentCategory: _plotParentCategory,
      plotChildCategory: _plotChildCategory,
      plotPointInputFormat: _plotPointInputFormat,
      plane_rectangular_cs_zone_jp: _plane_rectangular_cs_zone_jp
    };
  },
  methods: {
    getPlotParentCategoryIds() {
      let ids = [];
      Object.keys(_plotParentCategory.properties).forEach(key => {
        ids.push(_plotParentCategory.properties[key].id);
      });
      return ids.map(item => String(item));
    },
    getPlotChildCategoryIds() {
      let ids = [];
      Object.keys(_plotChildCategory.properties).forEach(key => {
        ids.push(_plotChildCategory.properties[key].id);
      });
      return ids.map(item => String(item));
    },
    getParentCategoryProps(id) {
      return _plotParentCategory.properties[id];
    },
    getPointInputFormatOptions() {
      return _.values(_plotPointInputFormat.properties)
    },
    getRectangularCoordinateOptions() {
      return _.values(_plane_rectangular_cs_zone_jp.properties)
    },
    getRectangularCoordinate(zone) {
      return _plane_rectangular_cs_zone_jp.properties[zone].coordinate
    }
  }
};
